import angular from 'angular';
import uiRouter from 'angular-ui-router';
import vehicleTradersManagementComponent from './vehicleTradersManagement.component';
import VehicleTradersContainer from './vehicleTradersContainer/vehicleTradersContainer'
import VehicleTraderManagementService from './vehicleTraderManagement.service'

let vehicleTradersManagementModule = angular.module('vehicleTradersManagement', [
  uiRouter,
  VehicleTradersContainer
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider
    .state('vehicleTradersManagement', {
      url: '/vehicleTradersManagement',
      component: 'vehicleTradersManagement'
    });
})

.component('vehicleTradersManagement', vehicleTradersManagementComponent)

.service('vehicleTraderManagementService', VehicleTraderManagementService)

.name;

export default vehicleTradersManagementModule;



// WEBPACK FOOTER //
// ./client/app/components/admin/vehicleTradersManagement/vehicleTradersManagement.js